import StorageService from '@/services/storage.service'
import storageKeys from '@/constants/storageKeys'
import { defaultFilters } from '@/models/PartnerTags/helpers'
import TableOptions from '@/models/TableOptions'
import { omitEmptyDeepFilters, prepareFilters } from '@/helpers/filters'
import offerPartnerTagsRepository from "@/repository/generatedRepository/offerPartnerTagsRepository";

const state = {
  list: [],
  filters: StorageService.get(storageKeys.OFFER_PARTNER_TAGS_FILTERS) || { ...defaultFilters() },
  tableOptions: TableOptions.defaultTableOptions(),
}

const getters = {
  filters: state => state.filters,
  tableOptions: state => state.tableOptions,
  list: state => state.list,
  isOpenFilterPanel: state =>
    state.filters.clientOptions && state.filters.clientOptions.filterPanelExpanded,
}

const actions = {
  async loadData(context, filters) {
    context.commit('setFilters', filters)
    StorageService.set(storageKeys.OFFER_PARTNER_TAGS_FILTERS, filters)

    const appliedFilters = omitEmptyDeepFilters(filters.filter)
    const appliedCfFilters = omitEmptyDeepFilters(filters.cfFilter)

    const preparedFilters = prepareFilters({
      ...filters,
      filter: appliedFilters,
      cfFilter: appliedCfFilters,
    })

    const { data } = await offerPartnerTagsRepository.list(preparedFilters)

    context.commit('setList', { data, filters })

    return { products: data.items, pagination: data.pagination }
  },
  async loadItem(context, id) {
    const { data } = await offerPartnerTagsRepository.get(id)
    return data
  },
  createItem(context, payload) {
    return offerPartnerTagsRepository.post(payload)
  },
  updateItem(context, payload) {
    const { id, ...data } = payload
    return offerPartnerTagsRepository.put(id, data)
  },
  deleteItem(context, payload) {
    return offerPartnerTagsRepository.delete(payload)
  },
  filtersStorageReset() {
    StorageService.remove(storageKeys.OFFER_PARTNER_TAGS_FILTERS)
  },
  updateFiltersClientOptions({ commit, getters }, clientOptions) {
    const updatedFilters = {
      ...getters.filters,
      clientOptions,
    }
    commit('setFilters', updatedFilters)
    StorageService.set(storageKeys.OFFER_PARTNER_TAGS_FILTERS, updatedFilters)
  },
}

const mutations = {
  setList(state, { data, filters }) {
    state.list = [...data.items]
    state.tableOptions = new TableOptions(data.pagination, filters)
  },
  setFilters(state, filters) {
    state.filters = { ...filters }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
